import { createSlice } from '@reduxjs/toolkit';
import { fetchFamilyDetails } from '../fetch/fetchFamilyDetails';

let fetch = fetchFamilyDetails;
const familyDetails = createSlice({
    name: "familyDetails",
    initialState: {
        isLoading: false,
        value: null,
        isError: false,
        showDialog: false,
        rbr: null,
    },
    extraReducers: (builder) => {
        builder.addCase(fetch.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(fetch.fulfilled, (state, action) => {
            state.isLoading = false;

            let data = action.payload;

            state.value = data;
        })
        builder.addCase(fetch.rejected, (state, action) => {
            state.isError = true;
        })
    },
    reducers: {
        setShowDialog(state, action) {
            state.showDialog = action.payload;
        },
        setRbr(state, action) {
            state.rbr = action.payload;
            state.showDialog = true;
        }
    }
});


export const selectFamilyDetails = (state) => state.familyDetails.value
export const selectLoadingFamilyDetails = (state) => state.familyDetails.isLoading
export const selectShowFamilyDetailsDialog = (state) => state.familyDetails.showDialog
export const selectFamilyDetailsRbr = (state) => state.familyDetails.rbr
export const { setShowDialog: setShowDialog, setRbr: setRbr } = familyDetails.actions

export default familyDetails.reducer

